/* WakeUp 2.5.1: ecommerce and UX events. No PII, no checkout conversion guesses. */
(function () {
  'use strict';
  if (!window.WUBPH || window.WUBPHEventsLoaded) return;
  window.WUBPHEventsLoaded = true;
  var cfg = window.WUBPHSettings || {};
  var lastVariant = String(cfg.variantId || '');
  var milestones = {}, comfortSeen = false, comfortObserver = null;
  function send(name, data) { window.WUBPH.capture(name, data || {}); }
  function productId() { return cfg.productId ? String(cfg.productId) : ''; }
  function currentVariant() {
    var input = document.querySelector('[data-wub-variant-input]');
    return input ? String(input.value || '') : lastVariant;
  }
  function trackPage() {
    milestones = {};
    comfortSeen = false;
    if (cfg.productId) {
      send('wub_product_viewed', {
        product_id: productId(),
        variant_id: currentVariant(),
        product_type: String(cfg.productType || ''),
        price: Number.isFinite(Number(cfg.priceCents)) ? Number(cfg.priceCents) / 100 : null
      });
    }
    watchComfort();
    checkScroll();
  }
  function watchComfort() {
    if (!window.IntersectionObserver || comfortSeen || !cfg.productId) return;
    if (comfortObserver) comfortObserver.disconnect();
    var card = document.querySelector('[data-wub-comfort-index-core]');
    if (!card) return;
    comfortObserver = new IntersectionObserver(function (entries) {
      if (entries.some(function (e) { return e.isIntersecting && e.intersectionRatio >= 0.2; })) {
        if (window.WUBPH.status().enabled && !comfortSeen) {
          comfortSeen = true;
          send('wub_comfort_index_viewed', { product_id: productId() });
          comfortObserver.disconnect();
          comfortObserver = null;
        }
      }
    }, { threshold: 0.2 });
    comfortObserver.observe(card);
  }
  function checkScroll() {
    if (!window.WUBPH.status().enabled) return;
    var total = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
    if (total < 200) return;
    var percent = Math.min(100, Math.round(window.scrollY / total * 100));
    [25, 50, 75, 90].forEach(function (point) {
      if (percent >= point && !milestones[point]) {
        milestones[point] = true;
        send('wub_scroll_depth', { depth_percent: point });
      }
    });
  }
  document.addEventListener('wub:posthog-ready', trackPage);
  document.addEventListener('wub:product-state-change', function (event) {
    var d = event.detail || {}, id = String(d.variantId || '');
    if (!id || id === lastVariant) return;
    lastVariant = id;
    if (['sticky-select', 'option-change', 'variant'].indexOf(String(d.reason || '')) < 0) return;
    send('wub_variant_selected', {
      product_id: productId(),
      variant_id: id,
      selection_method: d.reason === 'sticky-select' ? 'sticky' : 'product_options'
    });
  });
  document.addEventListener('cart:item-added', function (event) {
    var item = event.detail && event.detail.item || {};
    send('wub_add_to_cart', {
      product_id: String(item.product_id || productId()),
      variant_id: String(item.id || ''),
      quantity: Math.max(1, Number(item.quantity) || 1),
      price: Number.isFinite(Number(item.price)) ? Number(item.price) / 100 : null
    });
  });
  document.addEventListener('wub:cart-drawer-opened', function (event) {
    send('wub_cart_viewed', {
      view_type: 'drawer',
      open_reason: event.detail && event.detail.source === 'add-to-cart' ? 'after_add' : 'manual'
    });
  });
  document.addEventListener('wub:cart-item-removed', function (event) {
    send('wub_cart_item_removed', {
      view_type: 'drawer',
      item_count: Number(event.detail && event.detail.item_count) || 0
    });
  });
  document.addEventListener('cart:updated', function (event) {
    var d = event.detail || {};
    if (d.source === 'wub-cart' && d.action === 'remove') {
      send('wub_cart_item_removed', { view_type: 'cart_page', item_count: Number(d.item_count) || 0 });
    }
  });
  document.addEventListener('wub:checkout-click', function (event) {
    var src = String(event.detail && event.detail.source || '');
    send('wub_checkout_clicked', {
      source: src === 'cart' || src === 'drawer' ? src : 'other'
    });
  });
  document.addEventListener('wub:newsletter-popup-opened', function (event) {
    send('wub_popup_viewed', { popup_type: 'newsletter' });
    if (event.detail && event.detail.reason === 'server-success') {
      send('wub_newsletter_submitted', { method: 'server_confirmed' });
    }
  });
  document.addEventListener('change', function (event) {
    var target = event.target;
    if (target && target.matches && target.matches('[data-wub-filter-input]')) {
      send('wub_filter_applied', { page_type: 'collection', action: 'changed' });
    }
  });
  document.addEventListener('submit', function (event) {
    var form = event.target, action = (form && form.getAttribute('action')) || '';
    if (/\/search(?:\?|$)/.test(action)) send('wub_search_submitted', { search_origin: 'search_form' });
  });
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    if (target.closest('[data-wub-sticky-atc-button]')) {
      send('wub_sticky_atc_clicked', { product_id: productId() });
    }
    if (target.closest('[data-wub-size-sheet-open]')) {
      send('wub_size_guide_opened', { product_id: productId() });
    }
  });
  var ticking = false;
  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () { ticking = false; checkScroll(); });
  }, { passive: true });
  window.addEventListener('pagehide', function () {
    if (comfortObserver) comfortObserver.disconnect();
    comfortObserver = null;
  });
})();
